/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-07-22 15:27:02
 * @LastEditors: lwq
 * @LastEditTime: 2020-08-20 15:20:20
 * @FilePath: \mrc-base-server-view\src\utils\text_rules.js
 */
/*
* @params title 为空的时候提示
* @params arr 新增的rule判断
*/
export const text_rules = (title, arr = [], len = 50) => {
  return [
    v => !!v || title,
    ...arr,
    v => String(v).length <= len || '超过输入个数',
    // v => !/[@#$%^&()<>?/]/.test(v) || '请勿输入非法字符',
    v => !/^ +| +$/g.test(v) || '不能输入空格',
  ]
}
